import { Pipe, PipeTransform } from "@angular/core";

/**
 * Bold specified parts of a string based on a search.
 */
@Pipe({
  name: "bold"
})
export class BoldPipe implements PipeTransform {
  transform(text: string, controlValue: string): string {
    try {
      return controlValue ? text.replace(new RegExp(controlValue, "gi"), `<strong>$&</strong>`) : text;
    } catch {
      return text;
    }
  }
}
